import { useCallStateHooks } from "@stream-io/video-react-sdk";
import React, { useEffect, useMemo, useState } from "react";
import { BsMicMuteFill } from "react-icons/bs";




const formatTime = (seconds) => {
    const date = new Date(0);
    date.setSeconds(seconds);
    const format = date.toISOString();
    const hours = format.substring(11, 13);
    const minutes = format.substring(14, 16);
    const seconds_str = format.substring(17, 19);
    return `${hours !== "00" ? hours + ":" : ""}${minutes}:${seconds_str}`;
};

export const CallDuration = ({isMuted}) => {
    const [elapsed, setElapsed] = useState("00:00");
    const { useCallSession } = useCallStateHooks();
    const session = useCallSession();
    const startedAt = session?.started_at;
    const startedAtDate = useMemo(() => {
        if (!startedAt) {
            return Date.now();
        }
        const date = new Date(startedAt).getTime();
        return isNaN(date) ? Date.now() : date;
    }, [startedAt]);

    useEffect(() => {
        const initialElapsedSeconds = Math.max(
            0,
            (Date.now() - startedAtDate) / 1000,
        );

        setElapsed(formatTime(initialElapsedSeconds));

        const interval = setInterval(() => {
            const elapsedSeconds = (Date.now() - startedAtDate) / 1000;
            setElapsed(formatTime(elapsedSeconds));
        }, 1000);

        return () => clearInterval(interval);
    }, [startedAtDate]);

    return (
        <div className="flex items-center gap-2">
            <p className="text-white text-sm animate-pulse">{elapsed} </p>
            <BsMicMuteFill className={`${isMuted ? 'inline-block text-sm text-red-400' : 'hidden'}`} />
        </div>
            );
};